import * as type from './actionTypes';
import * as types from './types';

export const getBill = (payload: types.GetBillRequestPayload): types.GetBillRequest => ({
    type: type.GET_BILL,
    payload,
});

export const getBillSuccess = (payload: types.GetBillSuccessPayload): types.GetBillSuccess => ({
    type: type.GET_BILL_SUCCESS,
    payload,
});

export const getBillFailure = (payload: types.GetBillFailurePayload): types.GetBillFailure => ({
    type: type.GET_BILL_FAILURE,
    payload,
});

export const billCustomize = (payload: types.BillCustomizeRequestPayload): types.BillCustomizeRequest => ({
    type: type.BILL_CUSTOMIZE,
    payload,
});

export const billCustomizeSuccess = (payload: types.BillCustomizeSuccessPayload): types.BillCustomizeSuccess => ({
    type: type.BILL_CUSTOMIZE_SUCCESS,
    payload,
});

export const billCustomizeFailure = (payload: types.BillCustomizeFailurePayload): types.BillCustomizeFailure => ({
    type: type.BILL_CUSTOMIZE_FAILURE,
    payload,
});

export const orderHistory = (payload: types.OrderHistoryRequestPayload): types.OrderHistoryRequest => ({
    type: type.ORDER_HISTORY,
    payload,
});

export const orderHistorySuccess = (payload: types.OrderHistorySuccessPayload): types.OrderHistorySuccess => ({
    type: type.ORDER_HISTORY_SUCCESS,
    payload,
});

export const orderHistoryFailure = (payload: types.OrderHistoryFailurePayload): types.OrderHistoryFailure => ({
    type: type.ORDER_HISTORY_FAILURE,
    payload,
});

export const userPlans = (payload: types.UserPlansRequestPayload): types.UserPlansRequest => ({
    type: type.USER_PLANS,
    payload,
});

export const userPlansSuccess = (payload: types.UserPlansSuccessPayload): types.UserPlansSuccess => ({
    type: type.USER_PLANS_SUCCESS,
    payload,
});

export const userPlansFailure = (payload: types.UserPlansFailurePayload): types.UserPlansFailure => ({
    type: type.USER_PLANS_FAILURE,
    payload,
});

export const billForecast = (payload: types.BillForecastRequestPayload): types.BillForecastRequest => ({
    type: type.BILL_FORECAST,
    payload,
});

export const billForecastSuccess = (payload: types.BillForecastSuccessPayload): types.BillForecastSuccess => ({
    type: type.BILL_FORECAST_SUCCESS,
    payload,
});

export const billForecastFailure = (payload: types.BillForecastFailurePayload): types.BillForecastFailure => ({
    type: type.BILL_FORECAST_FAILURE,
    payload,
});

export const eligiblePayLater = (payload: types.EligiblePayLaterRequestPayload): types.EligiblePayLaterRequest => ({
    type: type.ELIGIBLE_PAY_LATER,
    payload,
});

export const eligiblePayLaterSuccess = (
    payload: types.EligiblePayLaterSuccessPayload,
): types.EligiblePayLaterSuccess => ({
    type: type.ELIGIBLE_PAY_LATER_SUCCESS,
    payload,
});

export const eligiblePayLaterFailure = (
    payload: types.EligiblePayLaterFailurePayload,
): types.EligiblePayLaterFailure => ({
    type: type.ELIGIBLE_PAY_LATER_FAILURE,
    payload,
});

export const billPay = (payload: types.BillPayRequestPayload): types.BillPayRequest => ({
    type: type.BILL_PAY,
    payload,
});

export const billPaySuccess = (payload: types.BillPaySuccessPayload): types.BillPaySuccess => ({
    type: type.BILL_PAY_SUCCESS,
    payload,
});

export const billPayFailure = (payload: types.BillPayFailurePayload): types.BillPayFailure => ({
    type: type.BILL_PAY_FAILURE,
    payload,
});

export const emailBill = (payload: types.EmailBillRequestPayload): types.EmailBillRequest => ({
    type: type.EMAIL_BILL,
    payload,
});

export const emailBillSuccess = (payload: types.EmailBillSuccessPayload): types.EmailBillSuccess => ({
    type: type.EMAIL_BILL_SUCCESS,
    payload,
});

export const emailBillFailure = (payload: types.EmailBillFailurePayload): types.EmailBillFailure => ({
    type: type.EMAIL_BILL_FAILURE,
    payload,
});

export const promisePay = (payload: types.PromisePayRequestPayload): types.PromisePayRequest => ({
    type: type.PROMISE_PAY,
    payload,
});

export const promisePaySuccess = (payload: types.PromisePaySuccessPayload): types.PromisePaySuccess => ({
    type: type.PROMISE_PAY_SUCCESS,
    payload,
});

export const promisePayFailure = (payload: types.PromisePayFailurePayload): types.PromisePayFailure => ({
    type: type.PROMISE_PAY_FAILURE,
    payload,
});

export const toggleIRILDDR = (payload: types.ToggleIRILDDRRequestPayload): types.ToggleIRILDDRRequest => ({
    type: type.TOGGLE_IRILDDR,
    payload,
});

export const toggleIRILDDRSuccess = (payload: types.ToggleIRILDDRSuccessPayload): types.ToggleIRILDDRSuccess => ({
    type: type.TOGGLE_IRILDDR_SUCCESS,
    payload,
});

export const toggleIRILDDRFailure = (payload: types.ToggleIRILDDRFailurePayload): types.ToggleIRILDDRFailure => ({
    type: type.TOGGLE_IRILDDR_FAILURE,
    payload,
});
export const getStatusIRILDDR = (payload: types.GetStatusIRILDDRRequestPayload): types.GetStatusIRILDDRRequest => ({
    type: type.GET_STATUS_IRILDDR,
    payload,
});

export const getStatusIRILDDRSuccess = (
    payload: types.GetStatusIRILDDRSuccessPayload,
): types.GetStatusIRILDDRSuccess => ({
    type: type.GET_STATUS_IRILDDR_SUCCESS,
    payload,
});

export const getStatusIRILDDRFailure = (
    payload: types.GetStatusIRILDDRFailurePayload,
): types.GetStatusIRILDDRFailure => ({
    type: type.GET_STATUS_IRILDDR_FAILURE,
    payload,
});

// get DR
export const getUsageDR = (payload: types.GetUsageDRRequestPayload): types.GetUsageDRRequest => ({
    type: type.GET_USAGE_DR,
    payload,
});

export const getUsageDRSuccess = (
    payload: types.GetUsageDRSuccessPayload,
): types.GetUsageDRSuccess => ({
    type: type.GET_USAGE_DR_SUCCESS,
    payload,
});

export const getUsageDRFailure = (
    payload: types.GetUsageDRFailurePayload,
): types.GetUsageDRFailure => ({
    type: type.GET_USAGE_DR_FAILURE,
    payload,
});

// get ILD
export const getUsageILD = (payload: types.GetUsageILDRequestPayload): types.GetUsageILDRequest => ({
    type: type.GET_USAGE_ILD,
    payload,
});

export const getUsageILDSuccess = (
    payload: types.GetUsageILDSuccessPayload,
): types.GetUsageILDSuccess => ({
    type: type.GET_USAGE_ILD_SUCCESS,
    payload,
});

export const getUsageILDFailure = (
    payload: types.GetUsageILDFailurePayload,
): types.GetUsageILDFailure => ({
    type: type.GET_USAGE_ILD_FAILURE,
    payload,
});

// get IR
export const getUsageIR = (payload: types.GetUsageIRRequestPayload): types.GetUsageIRRequest => ({
    type: type.GET_USAGE_IR,
    payload,
});

export const getUsageIRSuccess = (
    payload: types.GetUsageIRSuccessPayload,
): types.GetUsageIRSuccess => ({
    type: type.GET_USAGE_IR_SUCCESS,
    payload,
});

export const getUsageIRFailure = (
    payload: types.GetUsageIRFailurePayload,
): types.GetUsageIRFailure => ({
    type: type.GET_USAGE_IR_FAILURE,
    payload,
});

export const getAdvance = (payload: types.GetAdvanceRequestPayload): types.GetAdvanceRequest => ({
    type: type.GET_ADVANCE,
    payload,
});

export const getAdvanceSuccess = (payload: types.GetAdvanceSuccessPayload): types.GetAdvanceSuccess => ({
    type: type.GET_ADVANCE_SUCCESS,
    payload,
});

export const getAdvanceFailure = (payload: types.GetAdvanceFailurePayload): types.GetAdvanceFailure => ({
    type: type.GET_ADVANCE_FAILURE,
    payload,
});

export const dataUsage = (payload: types.DataUsageRequestPayload): types.DataUsageRequest => ({
    type: type.DATA_USAGE,
    payload,
});

export const dataUsageSuccess = (payload: types.DataUsageSuccessPayload): types.DataUsageSuccess => ({
    type: type.DATA_USAGE_SUCCESS,
    payload,
});

export const dataUsageFailure = (payload: types.DataUsageFailurePayload): types.DataUsageFailure => ({
    type: type.DATA_USAGE_FAILURE,
    payload,
});

export const payAdvance = (payload: types.PayAdvanceRequestPayload): types.PayAdvanceRequest => ({
    type: type.PAY_ADVANCE,
    payload,
});

export const payAdvanceSuccess = (payload: types.PayAdvanceSuccessPayload): types.PayAdvanceSuccess => ({
    type: type.PAY_ADVANCE_SUCCESS,
    payload,
});

export const payAdvanceFailure = (payload: types.PayAdvanceFailurePayload): types.PayAdvanceFailure => ({
    type: type.PAY_ADVANCE_FAILURE,
    payload,
});

export const config = (payload: types.ConfigRequestPayload):types.ConfigRequest => ({
    type: type.CONFIG,
    payload,
});

export const configSuccess = (payload: types.ConfigSuccessPayload): types.ConfigSuccess => ({
    type: type.CONFIG_SUCCESS,
    payload,
});

export const configFailure = (payload: types.ConfigFailurePayload): types.ConfigFailure => ({
    type: type.CONFIG_FAILURE,
    payload,
});

export const referalDetail = (payload: types.ReferalDetailRequestPayload): types.ReferalDetailRequest => ({
    type: type.REFERAL_DETAIL,
    payload,
});

export const referalDetailSuccess = (payload: types.ReferalDetailSuccessPayload): types.ReferalDetailSuccess => ({
    type: type.REFERAL_DETAIL_SUCCESS,
    payload,
});

export const referalDetailFailure = (payload: types.ReferalDetailFailurePayload): types.ReferalDetailFailure => ({
    type: type.REFERAL_DETAIL_FAILURE,
    payload,
});
